// extracted by mini-css-extract-plugin
module.exports = {"notFoundContainer":"NotFound_notFoundContainer__2OoQS","backButton":"NotFound_backButton__nK3JI"};